import React from 'react'
import { Link, RouterHelper, useOnNavigate } from '@morningtrain/react-navigation'
import { Env } from '@morningtrain/helpers'
import * as Auth from '@morningtrain/react-auth'
import SidebarMenuItem from 'ui/navigation/SidebarMenuItem'

function MenuItem (props) {
  const isRouteActive = (route) => {
    const parent = Env.get('page.parent')
    if (route && route === parent) {
      return true
    }

    return route === (new RouterHelper()).currentRoute
  }

  const hasLink = !!props.route

  const checkIfActive = () => {
    if (props.route && isRouteActive(props.route)) {
      return true
    }

    return false
  }

  const label = () => {
    if (props.label) {
      return props.label
    }

    if (hasLink) {
      const fragments = ('resources.' + props.route).split('.')
      const last = fragments.pop()
      return Env.get([...fragments, last, 'title'].join('.'))
    }

    return props.label
  }

  const [isActive, setIsActive] = React.useState(checkIfActive())

  useOnNavigate(() => {
    setIsActive(checkIfActive())
  })

  const handleOnClick = (e) => {
    if (typeof props.onClick === 'function') {
      props.onClick(e.target)
    }
  }

  const Item = (
    hasLink ? (
      <Link className='block group' route={props.route} onClick={handleOnClick}>
        <SidebarMenuItem active={isActive} text={label()} svgIcon={props.svgIcon} hasStatusBar={false} hasActiveBg={false} />
      </Link>
    ) : (
      <div className='block group' onClick={handleOnClick} route={props.route}>
        <SidebarMenuItem active={isActive} text={label()} svgIcon={props.svgIcon} hasStatusBar={false} hasActiveBg={false} />
      </div>
    )
  )

  if (props.route) {
    return (
      <Auth.Can permission={props.route}>
        {Item}
      </Auth.Can>
    )
  }

  return Item
}

export default MenuItem
